import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

import { get } from "../../utils/localStorage";
import { isEmpty as isStringEmpty } from "../../utils/string";

import Login from "modules/Retention/components/Login";

export default function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = get("token");
    const refreshToken = get("refreshToken");
    const userRole = get("userRole");

    if (!isStringEmpty(accessToken) || !isStringEmpty(refreshToken)) {
      navigate(userRole === "agency" ? "/retention/V2" : "/dashboard");
    }
  }, []);

  return (
    <>
      <Login />
    </>
  );
}
